import React from 'react';

const UcOtherAnswerImage: React.FC = () => {
  return (
    <svg
      width="48px"
      height="58px"
      viewBox="0 0 48 58"
      version="1.1"
      data-testid="svg-image"
    >
      <defs>
        <polygon
          id="path-1"
          points="0 78.944 77.961 78.944 77.961 0 0 0"
        ></polygon>
      </defs>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="UCS---Other-or-No-Answer"
          transform="translate(-401.000000, -88.000000)"
        >
          <g
            id="UCS---Other-or-Answer"
            transform="translate(386.000000, 77.000000)"
          >
            <mask id="mask-2" fill="white">
              <use href="#path-1"></use>
            </mask>
            <g id="mask"></g>
            <path
              d="M17,66.081 L60.901,66.081 L60.901,13 L17,13 L17,66.081 Z M61.901,68.081 L16,68.081 C15.448,68.081 15,67.634 15,67.081 L15,12 C15,11.447 15.448,11 16,11 L61.901,11 C62.453,11 62.901,11.447 62.901,12 L62.901,67.081 C62.901,67.634 62.453,68.081 61.901,68.081 Z M51.3442,40.5996 L33.9012,40.5996 C33.3492,40.5996 32.9012,40.1526 32.9012,39.5996 C32.9012,39.0466 33.3492,38.5996 33.9012,38.5996 L51.3442,38.5996 C51.8962,38.5996 52.3442,39.0466 52.3442,39.5996 C52.3442,40.1526 51.8962,40.5996 51.3442,40.5996 M29.4844,39.54 C29.4844,40.591 28.6324,41.44 27.5834,41.44 C26.5334,41.44 25.6824,40.591 25.6824,39.54 C25.6824,38.489 26.5334,37.64 27.5834,37.64 C28.6324,37.64 29.4844,38.489 29.4844,39.54 M51.3442,53.7236 L33.9012,53.7236 C33.3492,53.7236 32.9012,53.2766 32.9012,52.7236 C32.9012,52.1706 33.3492,51.7236 33.9012,51.7236 L51.3442,51.7236 C51.8962,51.7236 52.3442,52.1706 52.3442,52.7236 C52.3442,53.2766 51.8962,53.7236 51.3442,53.7236 M29.4844,52.664 C29.4844,53.715 28.6324,54.565 27.5834,54.565 C26.5334,54.565 25.6824,53.715 25.6824,52.664 C25.6824,51.614 26.5334,50.764 27.5834,50.764 C28.6324,50.764 29.4844,51.614 29.4844,52.664"
              id="icon"
              fill="#333E48"
              mask="url(#mask-2)"
            ></path>
            <path
              d="M25.9883,29.3173 C25.7233,29.3173 25.4683,29.2123 25.2803,29.0243 L22.3003,26.0433 C21.9103,25.6523 21.9103,25.0193 22.3013,24.6293 C22.6923,24.2383 23.3253,24.2383 23.7163,24.6293 L25.9883,26.9033 L31.4523,21.4383 C31.8423,21.0473 32.4753,21.0473 32.8663,21.4383 C33.2573,21.8293 33.2573,22.4623 32.8663,22.8523 L26.6953,29.0243 C26.5083,29.2123 26.2533,29.3173 25.9883,29.3173"
              id="Path"
              fill="#F9BE00"
              mask="url(#mask-2)"
            ></path>
            <path
              d="M51.3442,27.4746 L33.9012,27.4746 C33.3492,27.4746 32.9012,27.0276 32.9012,26.4746 C32.9012,25.9216 33.3492,25.4746 33.9012,25.4746 L51.3442,25.4746 C51.8962,25.4746 52.3442,25.9216 52.3442,26.4746 C52.3442,27.0276 51.8962,27.4746 51.3442,27.4746"
              id="Path"
              fill="#F9BE00"
              mask="url(#mask-2)"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default UcOtherAnswerImage;
